module.exports = __webpack_public_path__ + "img/202203-xl.f64112fd.png";